import React from 'react';
import {isJwtTokenExpired} from "../../js/Common";
import {jwtToken} from "../../js/services/LoginService";
import {Navigate, useLocation} from "react-router-dom";

export const PrivateRoute = ({children}) => {
  const tokenExpired = isJwtTokenExpired(jwtToken());

  const location = useLocation();

  let redirectPath = "/login";

  if(location.pathname && location.pathname !== "/app"){
    // Keep the query string (e.g. the KI-Integration consent request id) for the way back
    redirectPath = "/login?path=" + (location.search
        ? encodeURIComponent(location.pathname + location.search) : location.pathname);
  }

  return !tokenExpired ? children : <Navigate to={redirectPath}/>;
}
